import { Navigate } from 'react-router-dom'

import { getLocalizedPath, resolvePreferredLocale } from '@/content/i18n'

export function LocaleRedirect() {
  const locale = resolvePreferredLocale()
  return <Navigate replace to={getLocalizedPath(locale)} />
}
